import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CpagoComprasService {

  constructor(private httpClient: HttpClient) { }

  public insertar(_object: any) {
    return this.httpClient.post(environment.serviceUrl + "cpago-compras", _object, { observe: 'response' })
  }

  public actualizar(_object: any) {
    return this.httpClient.put(environment.serviceUrl + "cpago-compras", _object, { observe: 'response' })
  }

  public eliminar(codpag: number) {
    return this.httpClient.delete(environment.serviceUrl + "cpago-compras/" + codpag, { observe: 'response' })
  }

  public obtener(codpag: number) {
    return this.httpClient.get(environment.serviceUrl + "cpago-compras/" + codpag, { observe: 'response' })
  }

  public buscar() {
    return this.httpClient.get(environment.serviceUrl + "cpago-compras/buscar", { observe: 'response' })
  }

}
